import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    // Add cursor pointer to indicate image is clickable
    this.imageTarget.style.cursor = 'pointer'

    // Listen for escape key to close fullscreen
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener('keydown', this.boundHandleEscape)
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.boundHandleEscape)
    this.removeFullscreenOverlay()
  }

  openFullscreen() {
    // Create fullscreen overlay
    const overlay = document.createElement('div')
    overlay.className = 'fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200'
    overlay.id = 'fullscreen-image-overlay'

    // Create image container
    const imageContainer = document.createElement('div')
    imageContainer.className = 'relative max-w-full max-h-full'

    // Clone the image
    const fullscreenImage = this.imageTarget.cloneNode(true)
    fullscreenImage.className = 'object-contain rounded-lg shadow-2xl'
    fullscreenImage.style.cursor = 'default'
    // Bound to the viewport, not the auto-height container, so a tall portrait
    // shot fits fully instead of overflowing off the bottom.
    fullscreenImage.style.maxWidth = 'calc(100vw - 2rem)'
    fullscreenImage.style.maxHeight = 'calc(100vh - 2rem)'

    // Create close button
    const closeButton = document.createElement('button')
    closeButton.innerHTML = `
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        `
    closeButton.className = 'absolute top-4 right-4 w-12 h-12 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-all duration-200 backdrop-blur-sm border border-white/20 hover:border-white/40 focus:outline-none focus:ring-2 focus:ring-white/50'
    closeButton.setAttribute('aria-label', 'Close fullscreen')

    // Add elements to DOM
    imageContainer.appendChild(fullscreenImage)
    imageContainer.appendChild(closeButton)
    overlay.appendChild(imageContainer)
    document.body.appendChild(overlay)

    // Prevent body scroll
    document.body.style.overflow = 'hidden'

    // Add event listeners
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        this.closeFullscreen()
      }
    })

    closeButton.addEventListener('click', () => {
      this.closeFullscreen()
    })

    // Focus trap for accessibility
    closeButton.focus()
  }

  closeFullscreen() {
    this.removeFullscreenOverlay()
    document.body.style.overflow = ''
  }

  removeFullscreenOverlay() {
    const overlay = document.getElementById('fullscreen-image-overlay')
    if (overlay) {
      overlay.classList.add('animate-out', 'fade-out', 'duration-200')
      setTimeout(() => {
        overlay.remove()
      }, 200)
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.closeFullscreen()
    }
  }
}
